import { render, staticRenderFns } from "./SinglePolicy.vue?vue&type=template&id=140ec1ac&scoped=true"
import script from "./SinglePolicy.vue?vue&type=script&lang=js"
export * from "./SinglePolicy.vue?vue&type=script&lang=js"
import style0 from "./SinglePolicy.vue?vue&type=style&index=0&id=140ec1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ec1ac",
  null
  
)

export default component.exports